export default __webpack_public_path__ + "static/media/linkedinIcon.280a7c8e.svg";